// Copyright (c) StrangeBee 2024

import React, { ReactElement, useCallback } from 'react';
import { ObjectType } from 'thehive-sdk';
import { useLocalMessage } from '@Helpers/';
import THDrawer from '@Molecules/THDrawer/THDrawer';
import ResponderList from '@Organisms/Responder/ResponderList/ResponderList';

interface ResponderDrawerProps {
    objectType: ObjectType;
    objectId: string;
    triggerElem: ReactElement;
    objectData?: Record<string, string>;
}

const ResponderDrawer = ({
    objectType,
    objectId,
    triggerElem,
    objectData = {},
}: ResponderDrawerProps): ReactElement => {
    const i = useLocalMessage();

    const getTitleTrad = useCallback((): string => {
        if (!objectId) {
            return i(`responder.drawer.title.${objectType}.multiple`);
        }
        if (objectType === 'case' && objectData?.caseNumber) {
            return i(`responder.drawer.title.${objectType}.single`, { caseNumber: objectData?.caseNumber });
        }
        return i(`responder.drawer.title.${objectType}.single`);
    }, [objectId, objectType, objectData?.caseNumber, i]); // eslint-disable-next-line react-hooks/exhaustive-deps

    const title = getTitleTrad();

    return (
        <THDrawer title={title} triggerElem={triggerElem} width="35vw">
            <ResponderList objectId={objectId} objectType={objectType} />
        </THDrawer>
    );
};

export default ResponderDrawer;
